import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { InfoApto } from "../apto.type";
import { api } from "../api";
import { Carousel } from "react-responsive-carousel";
import btnStyle from "../btnStyle.module.css";
import { RxCheck } from "react-icons/rx";
import { Input, Breadcrumb, Modal } from "rsuite";
import { neighborhoodFilter } from "../components/FilterBar";
import { Button } from "../components/Button";
import { RiCloseLine, RiLoader2Line, RiMapPin2Fill } from "react-icons/ri";
import GoogleMapReact from "google-map-react";
import mapStyleJson from "../mapStyle.json";
import { arrowFoward, arrowPrev } from "../components/Arrows";
import {
  BiArea,
  BiArrowBack,
  BiSolidBed,
  BiSolidCarGarage,
} from "react-icons/bi";
import {
  LuBath,
  LuBed,
  LuCar,
  LuCheck,
  LuHome,
  LuHotel,
  LuRuler,
} from "react-icons/lu";
import { useZorm } from "react-zorm";
import { contactFormSchema, newsletterFormSchema } from "../contact.schema";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import axios from "axios";
import { slugify, urlPropertieGenerate } from "./Home";
import { Title } from "../aptos.type";
import { FaWhatsapp } from "react-icons/fa";

let info: InfoApto;

export function findNeighborhood(thisValue: number) {
  const labelOfValue = neighborhoodFilter.find(
    (value) => value.value === thisValue,
  );
  return labelOfValue?.label;
}

export function Properties() {
  const isMobile = window.innerWidth <= 768;

  let { slugId } = useParams();

  let id: any;

  const setId = slugId?.includes("--")
    ? (id = slugId?.split("--").pop())
    : (id = slugId);

  const isSlug = slugId?.includes("--");

  const navigate = useNavigate();
  const location = useLocation();

  const mapStyle = mapStyleJson;

  const carouselYoutubeMobileRelative =
    window.innerWidth > 768
      ? {
          centerMode: true,
          percentage: 34,
          initial: 2,
          infinity: true,
          swipeable: false,
          arrows: true,
        }
      : {
          centerMode: true,
          percentage: 95,
          initial: 3,
          infinity: true,
          swipeable: true,
          arrows: false,
        };

  const carouselYoutubeMobile =
    window.innerWidth > 768
      ? window.innerWidth > 2200
        ? {
            mobile: false,
            percentage: 45,
            width: 1030,
            height: 540,
            arrows: true,
          }
        : {
            mobile: false,
            percentage: 60,
            width: 1080,
            height: 540,
            arrows: true,
          }
      : {
          mobile: true,
          percentage: 87,
          width: 340,
          height: 256,
          arrows: true,
        };

  //@ts-ignore
  const [infoApto, setInfoApto] = useState(info);
  const [carouselImages, setCarouselImages] = useState(infoApto?.data?.images);
  const [isLoading, setIsLoading] = useState(false);
  const [initialImage, setInitialImage] = useState(2);

  const [imageFullScreen, setImageFullScreen] = useState([Boolean(false), 1]);

  const [emailLoading, setEmailLoading] = useState(false);

  async function getAptos() {
    setIsLoading(true);
    const data = await api.get(`properties/${id}`);
    return setInfoApto(data.data);
  }

  useEffect(() => {
    getAptos().then(() => {
      setCarouselImages(infoApto?.data?.images);
      setIsLoading(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    return;
  }, [location]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://d335luupugsy2.cloudfront.net/js/loader-scripts/98531bad-3c6c-46fc-ab38-0de641c99e27-loader.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // useEffect(() => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // }, [location]);

  const description =
    infoApto?.data.notes === null
      ? null
      : String(infoApto?.data.notes)
          .split("\n")
          // .map((item, i) => (i % 2 === 0 ? item + <br /> : null))
          // .map((item) => item?.slice(0, -15))
          .map((item) => {
            return <p>{item}</p>;
          });

  useEffect(() => emailjs.init("6KUX_UqfosafJ4VF5"), []);

  const zorm = useZorm(`/imovel/${id}`, contactFormSchema, {
    async onValidSubmit(event) {
      event.preventDefault();
      const sendData = {
        from_name: event.data.name,
        from_email: event.data.email,
        phone: event.data.phone,
        contact: event.data.contactWay,
        code: id,
      };
      const leadInfo = {
        name: event.data.name,
        ddd: "DDD",
        phone: event.data.phone,
        formText: event.data.contactWay,
        clientListingId: "0",
        email: event.data.email,
      };

      setEmailLoading(true);

      try {
        await axios.post(
          "https://prod.lastro.services/api/public/v1/leads/webhook/f9d1f7f6-6387-4440-86b0-9e153fe6f74d",
          leadInfo,
          { headers: { "Content-Type": "application/json" } },
        );

        emailjs.send("service_a75p5lo", "template_ctfa7zf", sendData).then(
          (result) => {
            toast.success("Email enviado com sucesso!");
            setEmailLoading(false);
          },
          (error) => {
            toast.error("Tente novamente em instantes...");
            setEmailLoading(false);
          },
        );
      } catch (e) {
        console.log(e);
      }
      return event.target.reset();
      //email rd-station
      // alert("lead enviado com sucesso!");
      // console.log("send contact");
    },
  });

  const newsletter = useZorm(`/imovel/${id}-newsletter`, newsletterFormSchema, {
    async onValidSubmit(event) {
      event.preventDefault();
      const sendData = {
        from_name: event.data.name,
        from_email: event.data.email,
        phone: "",
        contact: "Quero receber conteúdos exclusivos!",
        code: id,
      };

      const leadInfo = {
        name: event.data.name,
        ddd: "DDD",
        phone: "Newsletter",
        formText: "Newsletter",
        clientListingId: "0",
        email: event.data.email,
      };

      setEmailLoading(true);

      try {
        await axios.post(
          "https://prod.lastro.services/api/public/v1/leads/webhook/f9d1f7f6-6387-4440-86b0-9e153fe6f74d",
          leadInfo,
          { headers: { "Content-Type": "application/json" } },
        );

        emailjs.send("service_a75p5lo", "template_ctfa7zf", sendData).then(
          (result) => {
            toast.success("Email enviado com sucesso!");
            setEmailLoading(false);
          },
          (error) => {
            toast.error("Tente novamente em instantes...");
            setEmailLoading(false);
          },
        );
      } catch (e) {
        console.log(e);
      }
      return event.target.reset();
    },
  });

  let contactDisabled = zorm.validation?.success === false;
  let newsletterDisabled = newsletter.validation?.success === false;

  const [emailForm, setEmailForm] = useState("");
  const [nameForm, setNameForm] = useState("");
  const [phoneForm, setPhoneForm] = useState("");

  useEffect(() => {
    if (!infoApto || !id) return;

    const rightSlug = slugify(infoApto?.data?.meta_title);
    const rightURL = `${rightSlug}--${id}`;

    if (!isSlug) {
      navigate(`/imovel/${rightURL}`, { replace: true });
      return;
    }

    if (slugId !== rightURL) {
      navigate(`/imovel/${rightURL}`, { replace: true });
      return;
    }
  }, [infoApto, slugId]);

  useEffect(() => {
    if (!isMobile) return;

    if (Boolean(imageFullScreen[0])) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [imageFullScreen, isMobile]);

  return (
    <>
      {isLoading ? (
        <div className="flex items-center justify-center mt-32 mb-20 max-md:mt-44">
          <RiLoader2Line
            size={150}
            color="#b23437"
            className="animate-[spin_5s_linear_infinite]"
          />
        </div>
      ) : (
        <>
          <Helmet>
            <title>
              {infoApto?.data.meta_title
                ? infoApto?.data.meta_title
                : "Nossa Casa Imóveis"}
            </title>
            <meta
              name="description"
              content={infoApto?.data.meta_description}
            />
          </Helmet>
          {/* IMAGE FULLSCREEN */}
          {infoApto?.data.active ? (
            <>
              <Modal
                dialogClassName={
                  isMobile ? "modal-mobile-gallery" : "modal-carousel"
                }
                className="flex items-center justify-center"
                size="full"
                open={Boolean(imageFullScreen[0])}
                backdrop={true}
                backdropClassName="propertie-modal-backdrop"
                onClose={() => {
                  setImageFullScreen([false, Number(imageFullScreen[1])]);
                }}
              >
                {!isMobile && (
                  <Modal.Header classPrefix="fullscreen-propertie">
                    '
                  </Modal.Header>
                )}

                {isMobile ? (
                  <>
                    {/* BOTÃO FIXO */}
                    <button
                      onClick={() =>
                        setImageFullScreen([false, Number(imageFullScreen[1])])
                      }
                      className="mobile-gallery-close"
                    >
                      ×
                    </button>

                    {/* GALERIA */}
                    <div className="mobile-gallery-container">
                      {infoApto?.carouselImages.map((item, index) => (
                        <div key={index} className="mobile-gallery-item">
                          <img
                            src={item.url}
                            alt=""
                            className="mobile-gallery-image"
                          />
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <Carousel
                    infiniteLoop={true}
                    useKeyboardArrows={true}
                    showArrows={false}
                    showIndicators={false}
                    showThumbs={carouselYoutubeMobileRelative.arrows}
                    thumbWidth={100}
                    dynamicHeight={false}
                    showStatus={false}
                    transitionTime={850}
                    centerMode
                    centerSlidePercentage={100}
                    selectedItem={Number(imageFullScreen[1])}
                    onChange={(i) => setInitialImage(i)}
                    renderArrowNext={
                      carouselYoutubeMobileRelative.arrows
                        ? (clickHandler) =>
                            arrowFoward({
                              onClickHandler: clickHandler,
                              size: 80,
                            })
                        : undefined
                    }
                    renderArrowPrev={
                      carouselYoutubeMobileRelative.arrows
                        ? (clickHandler) =>
                            arrowPrev({
                              onClickHandler: clickHandler,
                              size: 80,
                            })
                        : undefined
                    }
                    className="
        flex flex-col items-center justify-center
        max-h-[90vh]
        carousel-exclusivos-inner
      "
                  >
                    {infoApto?.carouselImages.map((item, index) => (
                      <img
                        key={index}
                        src={item.url}
                        className="
            object-contain
            align-middle
            max-w-7xl
            px-2
            max-h-[75vh]
          "
                      />
                    ))}
                  </Carousel>
                )}
              </Modal>
              <div className="pt-32 " />

              <div className="flex items-center justify-start mx-[21%] max-md:mr-[5%] max-md:ml-[7%] leading-5 max-md:px-2 min-[2200px]:mx-[28%]">
                <Breadcrumb maxItems={7} separator={<>{`>`}</>}>
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="/imovel">Buscar</Breadcrumb.Item>
                  <Breadcrumb.Item
                    href={`/imovel?city=${infoApto?.data.city_id}`}
                  >
                    {infoApto?.data.address_city}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item
                    href={`/imovel?city=${infoApto?.data.city_id}&neighborhood=${infoApto?.data.neighborhood_id}`}
                  >
                    {infoApto?.data.address_neighborhood}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item
                    href={`/imovel?city=${infoApto?.data.city_id}&bedrooms=${infoApto?.data.bedrooms}&neighborhood=${infoApto?.data.neighborhood_id}`}
                  >
                    {infoApto?.data.bedrooms} Dormitórios
                  </Breadcrumb.Item>

                  <Breadcrumb.Item active>
                    {infoApto?.data.ad_title}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="flex flex-col items-center justify-center pb-24 overflow-x-hidden bg-transparent max-md:pb-10">
                <Carousel
                  infiniteLoop={true}
                  useKeyboardArrows={true}
                  showArrows={false}
                  showIndicators={false}
                  showThumbs={false}
                  showStatus={false}
                  transitionTime={850}
                  centerMode
                  centerSlidePercentage={carouselYoutubeMobile.percentage}
                  swipeScrollTolerance={45}
                  preventMovementUntilSwipeScrollTolerance
                  selectedItem={0}
                  onChange={(i) => setInitialImage(i)}
                  onClickItem={(index, item) => {
                    setInitialImage(index);
                    return initialImage === index
                      ? setImageFullScreen([true, index])
                      : null;
                  }}
                  className="flex items-center justify-center object-cover rounded-3xl w-[100%] carousel-control-div"
                >
                  {infoApto?.carouselImages.map((item) => {
                    return (
                      <div className="w-[100%] rounded-3xl h-[600px] max-w-7xl cursor-pointer max-md:h-auto">
                        <img
                          src={item?.url}
                          className="object-cover rounded-3xl h-[600px] w-[100%] max-w-7xl px-2 max-md:h-auto max-md:max-h-64 max-md:min-h-[16rem]"
                        />
                      </div>
                    );
                  })}
                </Carousel>
                {!infoApto?.data.videos.length ? null : (
                  <>
                    <div className="mt-8 rounded-3xl">
                      <iframe
                        className="rounded-3xl"
                        width={carouselYoutubeMobile.width}
                        height={carouselYoutubeMobile.height}
                        src={`https://www.youtube.com/embed/${infoApto?.data.videos[0]?.url}?controls=1&modestbranding=1&amp;rel=0&amp;showinfo=0`}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Embedded youtube"
                      />
                    </div>
                  </>
                )}
                <div className="grid w-full max-w-7xl gap-10 xl:grid-cols-[1.5fr_0.9fr] lg:pt-8">
                  <div className="space-y-8">
                    <div className="p-8 bg-white shadow-xl rounded-3xl">
                      <div className="space-y-6">
                        <div className="grid gap-4 sm:grid-cols-[1fr_auto] items-start">
                          <div>
                            <h2 className="text-3xl font-semibold text-[#1f1f21]">
                              {infoApto?.data.ad_title}
                            </h2>
                            <p className="mt-3 text-base text-[#1f1f21] italic">
                              {infoApto?.data.address_neighborhood} |{" "}
                              {infoApto?.data.address_city} | Código do imóvel{" "}
                              {infoApto?.data.identifier_code}
                            </p>
                            <br />
                            <p className="text-4xl font-bold text-[#b23437]">
                              {"R$" +
                                infoApto?.data.sale_value.replace(
                                  /(\d)(?=(\d{3})+(?!\d))/g,
                                  "$1.",
                                )}
                            </p>
                          </div>
                        </div>

                        <div className="bg-[#b23437] p-6 text-white ml-[-32px] mr-[-32px] pt-10 pb-10">
                          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                            {!infoApto?.data.private_area ? null : (
                              <div className="flex items-center gap-3">
                                <LuRuler size={"28px"} />
                                <span>
                                  {infoApto?.data.private_area}m² de área
                                  privativa
                                </span>
                              </div>
                            )}
                            {!infoApto?.data.garages ? null : (
                              <div className="flex items-center gap-3">
                                <LuCar size={"28px"} />
                                <span>
                                  {infoApto?.data.garages}{" "}
                                  {infoApto?.data.garages === 1
                                    ? "vaga de garagem"
                                    : "vagas de garagem"}
                                </span>
                              </div>
                            )}
                            {!infoApto?.data.bedrooms ? null : (
                              <div className="flex items-center gap-3">
                                <LuBed size={"28px"} />
                                <span>
                                  {infoApto?.data.bedrooms}{" "}
                                  {infoApto?.data.bedrooms === 1
                                    ? "dormitório"
                                    : "dormitórios"}
                                </span>
                              </div>
                            )}
                            {!infoApto?.data.suites ? null : (
                              <div className="flex items-center gap-3">
                                <LuBath size={"28px"} />
                                <span>
                                  {infoApto?.data.suites}{" "}
                                  {infoApto?.data.suites === 1
                                    ? "suíte"
                                    : "suítes"}
                                </span>
                              </div>
                            )}
                            {!infoApto?.data.iptu_value ? null : (
                              <div className="flex items-center gap-3">
                                <LuHome size={"28px"} />
                                <span>
                                  {" "}
                                  IPTU: R$
                                  {infoApto?.data.iptu_value.replace(
                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1.",
                                  )}
                                </span>
                              </div>
                            )}
                            {infoApto?.data.show_condominium_value ? (
                              <div className="flex items-center gap-3">
                                <LuHotel size={"28px"} />
                                <span>
                                  {" "}
                                  Condomínio: R$
                                  {infoApto?.data.condominium_value.replace(
                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1.",
                                  )}
                                </span>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <br />
                      <br />
                      <div>
                        <h3 className="text-xl font-semibold text-[#1f1f21] mb-4">
                          Descrição:
                        </h3>
                        <p className="text-base text-[#3b3b3f] leading-relaxed">
                          {description}
                        </p>
                      </div>
                      {infoApto?.data.property_infrastructures.length ? (
                        <div>
                          <br />
                          <h3 className="text-xl font-semibold text-[#1f1f21] mb-4">
                            Comodidades:
                          </h3>
                          <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 text-[#1f1f21]">
                            {infoApto?.data.property_infrastructures.map(
                              (item, index) => (
                                <li
                                  key={index}
                                  className="flex items-center gap-2"
                                >
                                  <LuCheck
                                    size={18}
                                    className="text-[#b23437]"
                                  />
                                  <span>{item}</span>
                                </li>
                              ),
                            )}
                          </ul>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="space-y-6">
                    <div className="w-full overflow-hidden shadow-xl rounded-3xl h-72 md:h-80">
                      <GoogleMapReact
                        bootstrapURLKeys={{
                          key: "AIzaSyCU6Z8Q0FQ5FPhJWonDtcRUdFKqbVWgX7U",
                          language: "pt-br",
                        }}
                        center={{
                          lat: Number(infoApto?.data.latitude)
                            ? Number(infoApto?.data.latitude)
                            : 0,
                          lng: Number(infoApto?.data.longitude)
                            ? Number(infoApto?.data.longitude)
                            : 0,
                        }}
                        zoom={15}
                        options={{
                          styles: mapStyle,
                          clickableIcons: false,
                          gestureHandling: "none",
                        }}
                      >
                        <RiMapPin2Fill
                          size={40}
                          color="#b23437"
                          className="translate-x-[-25px] translate-y-[-40px] font-thin"
                        />
                      </GoogleMapReact>
                    </div>

                    <div className="rounded-3xl bg-[#2B2E33] p-12 shadow-xl text-white">
                      <h3 className="pb-4 text-xl font-semibold text-center">
                        Quer visitar ou saber mais sobre esse imóvel?
                      </h3>
                      <form className="flex flex-col gap-3" ref={zorm.ref}>
                        <Input
                          placeholder="Nome Completo"
                          id="name"
                          type="text"
                          name={zorm.fields.name()}
                          value={nameForm}
                          onChange={(i) => setNameForm(i)}
                          className="w-full"
                        />
                        {zorm.errors.name((error) => (
                          <span className="px-1 text-sm text-[#A81F24] max-md:text-center">
                            {error.message}
                          </span>
                        ))}
                        <Input
                          placeholder="Telefone"
                          id="phone"
                          name={zorm.fields.phone()}
                          value={phoneForm}
                          onChange={(i) => setPhoneForm(i)}
                          type="number"
                          pattern="[0-9]*"
                          className="w-full"
                        />
                        {zorm.errors.phone((error) => (
                          <span className="px-1 text-sm text-[#A81F24] max-md:text-center">
                            {error.message}
                          </span>
                        ))}
                        <Input
                          className="w-full email-form"
                          placeholder="Email"
                          id="email"
                          type="email"
                          name={zorm.fields.email()}
                          value={emailForm}
                          onChange={(i) => setEmailForm(i)}
                        />
                        {zorm.errors.email((error) => (
                          <span className="px-1 text-sm text-[#A81F24] max-md:text-center">
                            {error.message}
                          </span>
                        ))}
                        <Input
                          placeholder="Forma de Contato"
                          id="contact"
                          name={zorm.fields.contactWay()}
                          className="w-full"
                        />
                        <button
                          disabled={contactDisabled}
                          className={`${btnStyle.button2} w-full rounded-lg bg-[#A81F24] px-6 py-3 font-semibold text-base ${
                            emailLoading ? "cursor-wait" : ""
                          }`}
                          type="submit"
                        >
                          Enviar
                        </button>
                      </form>
                      <button
                        className={`${btnStyle.button2} mt-4 w-full rounded-lg bg-[#39B54A] px-6 py-3 text-base font-semibold text-white`}
                        onClick={() => {
                          window.open(
                            `https://wa.me/555136642000?text=${encodeURIComponent("Olá, gostaria de mais informaçoes sobre o imóvel código: ")}${infoApto?.data.identifier_code}`,
                            "_blank",
                          );
                        }}
                      >
                        <div className="flex items-center justify-center gap-2">
                          <FaWhatsapp />
                          Fale por Whatsapp
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="pt-32 ">
              <h3 className="py-20 px-44 max-md:px-10">
                Imóvel indisponível...
              </h3>
            </div>
          )}
          <section className="pt-10 pb-10 border-t-4 bg-white border-t-[#b23437] max-md:py-10 max-md:overflow-hidden">
            <div className="flex flex-col items-center justify-center">
              <div className="flex flex-col items-center justify-center pb-4 scale-125 max-md:scale-100">
                <h3 className="text-[#b23437] font-bold">Imóveis similares</h3>
                <span className="text-[#AEAEAE] text-center px-10">
                  Continue sua busca
                </span>
              </div>

              <div className="grid-flow-col grid-cols-3 max-w-7xl max-md:max-w-full max-md:scale-95 max-[950px]:max-w-[900px]">
                <Carousel
                  swipeable={carouselYoutubeMobileRelative.swipeable}
                  showThumbs={false}
                  showIndicators={false}
                  showArrows={carouselYoutubeMobileRelative.arrows}
                  showStatus={false}
                  transitionTime={1000}
                  swipeScrollTolerance={45}
                  preventMovementUntilSwipeScrollTolerance
                  centerMode={carouselYoutubeMobileRelative.centerMode}
                  centerSlidePercentage={
                    carouselYoutubeMobileRelative.percentage
                  }
                  selectedItem={carouselYoutubeMobileRelative.initial}
                  infiniteLoop={carouselYoutubeMobileRelative.infinity}
                  className="carousel-exclusivos"
                  renderArrowNext={
                    carouselYoutubeMobileRelative.arrows
                      ? (clickHandler) =>
                          arrowFoward({
                            onClickHandler: clickHandler,
                            size: 20,
                          })
                      : undefined
                  }
                  renderArrowPrev={
                    carouselYoutubeMobileRelative.arrows
                      ? (clickHandler) =>
                          arrowPrev({
                            onClickHandler: clickHandler,
                            size: 20,
                          })
                      : undefined
                  }
                >
                  {infoApto?.relativeProperties.map((info, i) => {
                    return (
                      <div
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        key={i}
                        className="scale-95 bg-white flex flex-col justify-between space-y-0 h-auto border-solid border-2 border-[#F5F5F5] max-w-lg m-2 rounded-xl pb-6 min-h-[32rem] max-md:ml-0 max-md:mr-5 max-md:scale-100 max-md:max-w-lg max-md:min-h-[34rem]"
                      >
                        {/* {carouselYoutubeMobile.arrows ? null : (
                          <div className="bg-transparent w-[40%] h-[70%] z-50 fixed left-20 touch-pan-x">
                            {" "}
                          </div>
                        )} */}
                        <Carousel
                          infiniteLoop
                          swipeable={false}
                          transitionTime={850}
                          showStatus={false}
                          showThumbs={false}
                          className="cursor-pointer carousel-exclusivos-inner"
                          renderArrowNext={(clickHandler) =>
                            arrowFoward({
                              onClickHandler: clickHandler,
                              size: 30,
                            })
                          }
                          renderArrowPrev={(clickHandler) =>
                            arrowPrev({
                              onClickHandler: clickHandler,
                              size: 30,
                            })
                          }
                          onClickItem={() => {
                            // console.log(info);
                            navigate(`/imovel/${info.identifier_code}`);
                          }}
                        >
                          {info?.images.slice(0, 4).map((item, i) => {
                            return (
                              <>
                                <div
                                  className="max-w-lg rounded-t-xl h-72 max-md:h-80"
                                  onClick={(event) => event.preventDefault()}
                                >
                                  {info?.has_exclusivity && i === 0 ? (
                                    <>
                                      <div className="">
                                        <button className="bg-[#DAA14A] text-xs pointer-events-none fixed top-4 right-[-7rem] w-28 rounded-r-xl text-white pr-4 py-2 text-right">
                                          Exclusividade
                                        </button>
                                      </div>
                                    </>
                                  ) : null}
                                  <img
                                    loading="lazy"
                                    src={item.thumbnail_url}
                                    className="rounded-t-xl h-72 max-md:h-80"
                                  />
                                </div>
                              </>
                            );
                          })}
                        </Carousel>
                        <div className="mt-0">
                          <div className="bg-[#ececec] p-2 flex items-center justify-center">
                            <RiMapPin2Fill
                              color="#b23437"
                              className="mt-1 mb-2 mr-1"
                              size={17}
                            />
                            {info?.address_neighborhood} - {info?.address_city}
                          </div>
                        </div>
                        <div className="flex flex-col items-center justify-center">
                          <span className="px-2 pt-5 pb-1 text-xl font-bold">
                            {"R$" +
                              info?.sale_value.replace(
                                /(\d)(?=(\d{3})+(?!\d))/g,
                                "$1.",
                              )}
                          </span>
                          {info.meta_title ? (
                            <h6 className="px-10 pt-2 pb-3 text-sm font-normal text-center">
                              {info?.meta_title.length >= 43
                                ? `${info?.meta_title.substring(0, 43)}...`
                                : info?.meta_title}
                            </h6>
                          ) : (
                            <br />
                          )}
                        </div>
                        <div className="flex justify-center gap-4 mx-5 text-xs font-medium max-md:mx-2 max-md:gap-4">
                          <span
                            className={`flex items-center justify-center gap-1 `}
                          >
                            <BiArea size={"22px"} />
                            {info?.private_area ? (
                              <>{info?.private_area} m²</>
                            ) : (
                              <>Consulte</>
                            )}
                          </span>

                          {/* {info.private_area ? (
                          <span
                            className={`flex items-center justify-center gap-1 ${
                              info?.private_area ? "flex" : "hidden"
                            }`}
                          >
                            <BiArea size={"22px"} />
                            {info?.private_area} m²
                          </span>
                        ) : (
                          <br />
                        )} */}
                          <span
                            className={`items-center justify-center gap-1 flex`}
                          >
                            <BiSolidBed size={"22px"} />

                            {info?.bedrooms === 0 ? (
                              <>Consulte</>
                            ) : (
                              <>{info?.bedrooms} Dormitórios</>
                            )}
                          </span>
                          <span
                            className={`items-center justify-center gap-1 flex`}
                          >
                            <BiSolidCarGarage size={"22px"} />
                            {info?.garages === 0 ? (
                              <>Consulte</>
                            ) : (
                              <>{info?.garages} Vagas</>
                            )}
                          </span>
                        </div>
                        <div className="flex items-center justify-center pt-4">
                          <Button
                            label="Saiba mais"
                            link={`/imovel/${info?.identifier_code}`}
                          />
                        </div>
                      </div>
                    );
                  })}
                </Carousel>

                <span
                  className="flex items-center justify-center text-[#1f1f21] hover:underline cursor-pointer max-md:pt-10"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <BiArrowBack color="#b23437" size={20} />
                  <h6 className="pl-1">voltar</h6>
                </span>
              </div>
            </div>
          </section>
          <section className="bg-[#b23437f8] pt-10 pb-3 flex items-center justify-center pl-4 pr-12 max-md:pl-12">
            <div className="flex items-center justify-center max-w-5xl text-white max-md:flex-col">
              <div className="mr-5 max-md:ml-5 max-md:pt-8">
                <h5 className="text-3xl font-normal max-md:text-center max-md:text-2xl max-md:px-4">
                  <b>Quer receber conteúdos exclusivos?</b>
                </h5>
                <p className="text-base font-normal max-md:ml-5 max-md:mt-5">
                  As melhores informações sobre o mercado imobiliário, dicas de
                  como curtir a praia, curiosidades de Torres/RS, programação
                  semanal e muito mais.
                </p>
              </div>

              <div className="border-l-[#C76C6E] border-l-2 max-h-48 mb-6 max-md:border-l-0">
                <form
                  className="flex flex-col p-10 gap-y-2"
                  ref={newsletter.ref}
                >
                  <Input
                    placeholder="Nome"
                    id="name"
                    name={newsletter.fields.name()}
                    type="text"
                  />
                  {newsletter.errors.name((error) => {
                    return (
                      <span className="px-1 text-sm text-white max-md:text-center">
                        {error.message}
                      </span>
                    );
                  })}
                  <Input
                    placeholder="Email"
                    id="email-news"
                    name={newsletter.fields.email()}
                    type="email"
                  />
                  {newsletter.errors.email((error) => {
                    return (
                      <span className="px-1 text-sm text-white max-md:text-center">
                        {error.message}
                      </span>
                    );
                  })}
                  <button
                    disabled={newsletterDisabled}
                    className={`${
                      btnStyle.button2
                    } w-fit px-28 py-2 bg-[#A81F24] font-semibold text-base rounded-lg ${
                      emailLoading ? "cursor-wait" : ""
                    }`}
                    type="submit"
                  >
                    Enviar
                  </button>
                </form>
              </div>
            </div>
          </section>
          <ToastContainer />
        </>
      )}
    </>
  );
}
